// extracted by mini-css-extract-plugin
module.exports = {"brand-chip":"BrandChip_brand-chip__C_oQ2","active":"BrandChip_active__WhKnz","hover":"BrandChip_hover__idtJ0"};